import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { supabase } from '../lib/supabase';

const SubscriptionSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [nameShort, setNameShort] = useState<string>('');
  const [isMale, setIsMale] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return;
        const { data: profile } = await supabase
          .from('profiles')
          .select('name_short, name_sex_male')
          .eq('id', user.id)
          .single();
        if (profile) {
          setNameShort((profile as any).name_short || '');
          const male = (profile as any)?.name_sex_male === null ? true : !!(profile as any)?.name_sex_male;
          setIsMale(male);
        }
      } catch {}
    })();
  }, []);

  return (
    <div className="w-full min-h-[100dvh] md:min-h-screen md:flex md:items-center md:justify-center bg-white md:bg-transparent">
      <div className="relative bg-white w-full min-h-[100dvh] md:min-h-0 px-4 md:px-8 py-10 md:py-12 pb-28 md:pb-12 md:max-w-4xl md:mx-auto md:rounded-2xl md:shadow-sm flex items-center justify-center">
        <div className="max-w-md w-full text-center">
          <div className="mx-auto mb-6 w-20 h-20 rounded-full bg-green-500 flex items-center justify-center">
            <Check className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-2xl font-semibold text-gray-900 mb-2">Subscripción exitosa.</h1>
          <p className="text-gray-700">
            {`${nameShort ? `${nameShort}, ` : ''}${isMale ? 'bienvenido' : 'bienvenida'} a la revolución de la IA.`}
          </p>
          {/* Desktop inline helper + button */}
          <div className="hidden md:block mt-8">
            <p className="text-xs text-gray-500 mb-2">Ante cualquier duda te podes comunicar con nostros yendo a la pestaña de Ayuda.</p>
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center justify-center h-10 px-6 bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-sm focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
      {/* Mobile fixed bottom actions */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white px-4 py-4 border-t border-gray-200">
        <p className="text-xs text-gray-500 mb-2 text-center">Ante cualquier duda te podes comunicar con nostros yendo a la pestaña de ayuda.</p>
        <button
          onClick={() => navigate('/')}
          className="w-full h-12 bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Continuar
        </button>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
